import * as React from 'react';
import { Chip } from '@mui/material';
import { withTranslation } from 'react-i18next';

const statusConfig = {
  pending: {
    color: '#92400e',
    bgcolor: '#fef3c7',
    borderColor: '#fcd34d',
  },
  confirmed: {
    color: '#1e40af',
    bgcolor: '#dbeafe',
    borderColor: '#93c5fd',
  },
  delivered: {
    color: '#065f46',
    bgcolor: '#d1fae5',
    borderColor: '#6ee7b7',
  },
  partially_delivered: {
    color: '#9a3412',
    bgcolor: '#ffedd5',
    borderColor: '#fed7aa',
  },
  cancelled: {
    color: '#991b1b',
    bgcolor: '#fee2e2',
    borderColor: '#fca5a5',
  },
};

const SupplierOrderStatusBadge = ({ status, t, size = 'small' }) => {
  const config = statusConfig[status] || statusConfig.pending;
  const label = t('purchaseOrders.status.' + status);

  return (
    <Chip
      label={label}
      size={size}
      sx={{
        color: config.color,
        bgcolor: config.bgcolor,
        border: `1px solid ${config.borderColor}`,
        fontWeight: 500,
        fontSize: size === 'small' ? '11px' : '12px',
        height: size === 'small' ? '22px' : '26px',
        '& .MuiChip-label': {
          px: 1,
        },
      }}
    />
  );
};

export default withTranslation()(SupplierOrderStatusBadge);
